import { Currency } from '@interticket/core';
import { IPriceCategory } from '@core/interfaces/product/pricing-category.interface';

export const PRICE_CATEGORY_LIST: IPriceCategory[] = [
  {
    id: 'f50abd72-6e61-4c79-8f93-39b0835b3693',
    name: 'PriceCategory2 name',
    currency: Currency.HUF,
    maxCapacity: 499,
    availableCapacity: 200,
    price: 9990,
    group: 'Hétköznap',
  },
  {
    id: 'f50abd72-6e61-4c79-8f93-39b0835b3693',
    name: 'PriceCategory2 name',
    currency: Currency.HUF,
    maxCapacity: 499,
    availableCapacity: 200,
    price: 9990,
    group: 'Hétköznap',
  },
  {
    id: 'f50abd72-6e61-4c79-8f93-39b0835b3693',
    name: 'PriceCategory2 name',
    currency: Currency.HUF,
    maxCapacity: 499,
    availableCapacity: 200,
    price: 9990,
    group: 'Hétköznap',
  },
  {
    id: 'd7609504-080d-48ec-b9f1-923533cf7d60',
    name: 'PriceCategory3 name',
    currency: Currency.HUF,
    maxCapacity: 250,
    availableCapacity: 90,
    price: 0,
    group: 'Hétvége',
  },
];

export const PRICE_CATEGORY_FREE: IPriceCategory[] = [
  {
    id: 'f50abd72-6e61-4c79-8f93-39b0835b3693',
    name: 'Free Event',
    currency: Currency.HUF,
    maxCapacity: 250,
    availableCapacity: 80,
    price: 0,
    group: 'Hétvége',
  },
];
